import React from "react";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import MuiTextField from "@material-ui/core/TextField";

import LuxonUtils from "@date-io/luxon";
import DateTime from "luxon/src/datetime";

const TextField = (props) => <MuiTextField {...props} variant="outlined" size={"small"}/>

export const DateTimeSelect = (props) => {
  const { name, label, value, content, setFieldValue, disabled, error, touched } = props;
  const onChangeDateTime = (dateTime) => {
    setFieldValue(name, dateTime.toString().split('+')[0].split('.')[0]+'Z', false);
  };

  return (
    <MuiPickersUtilsProvider utils={LuxonUtils} locale={"ru"}>
      <KeyboardDateTimePicker
        allowKeyboardControl={false}
        label={label}
        fullWidth
        error={error && touched && Boolean(error)}
        format={"dd MMMM yyyy HH:mm:ss"}
        ampm={false}
        value={
          value && typeof value === "string"
            ? DateTime.fromISO(value).toJSDate().toISOString().slice(0, -1)
            : value === null
            ? null
            : value.toJSDate().toISOString().slice(0, -1)
        }
        disabled={disabled}
        disableFuture={ false
          // content?.disableFuture === null ||
          // content?.disableFuture === undefined
          //   ? true
          //   : content?.disableFuture
        }
        InputProps={{ readOnly: true }}
        TextFieldComponent={TextField}
        onChange={onChangeDateTime}
      />
    </MuiPickersUtilsProvider>
  );
};
